import React, { useState } from 'react';
import { inject, observer } from "mobx-react";
import { VideoPreview, HighlightPreview, DotLoader } from '@myplay/ui';

import { VideoPreviewActions } from '..';
import I18N from '../../I18N';
import { toTitleCase, capitalize } from '../../utils/stringManipulations';
import { AWAY, HOME, SHARE, DELETE, DOWNLOAD, ASSIGN_ASSISTANT } from '../../utils/constants';
import "./TeamRecentVideos.scss";

const TeamRecentVideos = ({ isGames = true, TeamsStore, VideosStore , onClick }) => {
  const { selectedTeam: { videos, highlights, members, _id }, getTeamRecentVideos, getTeamHighlights } = TeamsStore;
  const { changeVideoTitle, updateGameScore } = VideosStore;
  const [displayedModal, setDisplayedModal] = useState("");
  const [selectedVideoContainer, setSelectedVideoContainer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLoadMore = async () => {
    setIsLoading(true);
    const itemsCount = isGames ? videos.length : highlights.length;
    setError("");
    if (isGames) {
      await getTeamRecentVideos(_id, 4, videos.length, false);
      setError(itemsCount === videos.length ? I18N.t("LOAD_MORE_VIDEOS_ERROR") : "");
    } else {
      await getTeamHighlights(_id, 4, highlights.length, false);
      setError(itemsCount === highlights.length ? I18N.t("LOAD_MORE_HIGHLIGHTS_ERROR") : "");
    }
    setIsLoading(false);
  };

  const handleVideoClick = video => {
    onClick(video);
  }

  const handleChangeGameTitle = (videoId, newTitle) => {
    changeVideoTitle(videoId, newTitle);
  };

  const handleUpdateAwayScore = (videoId, score) => {
    updateGameScore(videoId, score, AWAY);
  };

  const handleUpdateHomeScore = (videoId, score) => {
    updateGameScore(videoId, score, HOME);
  };

  const handleShare = videoContainer => {
    setSelectedVideoContainer(videoContainer);
    setDisplayedModal(SHARE);
  };

  const handleDelete = videoContainer => {
    setSelectedVideoContainer(videoContainer);
    setDisplayedModal(DELETE);
  };

  const handleDownload = videoContainer => {
    setSelectedVideoContainer(videoContainer);
    setDisplayedModal(DOWNLOAD);
  };

  const handleAssignAssistant = videoContainer => {
    setSelectedVideoContainer(videoContainer);
    setDisplayedModal(ASSIGN_ASSISTANT);
  };

  const closeModal = ()=> {
    setSelectedVideoContainer(null);
    setDisplayedModal("");
  };

  return (
    <div className="team-recent-videos">
      <p className="team-recent-videos__title">{toTitleCase(I18N.t(isGames ? "TEAM_VIDEOS" : "HIGHLIGHTS"))}</p>
      <div className="team-recent-videos__videos-container">
        {isGames ?
          videos.map(video =>
            <div key={video.id} className="team-recent-videos__videos-container__single-video-wrapper">
              <VideoPreview
                videoContainer={video}
                onDelete={handleDelete}
                onDownload={handleDownload}
                onClick={()=> handleVideoClick(video)}
                changeGameTitle={handleChangeGameTitle}
                updateAwayScore={handleUpdateAwayScore}
                updateHomeScore={handleUpdateHomeScore}
                onShare={handleShare}
                onAssignAssistant={handleAssignAssistant}
              />
            </div>
          ) :
          highlights.map(highlight =>
            <div key={highlight.id} className="team-recent-videos__videos-container__single-video-wrapper">
              <HighlightPreview highlight={highlight} onClick={handleVideoClick} />
            </div>
          )
        }
      </div>
      {isLoading && <DotLoader />}
      {error && <p className="team-recent-videos__error">{capitalize(error)}</p>}
      <button className="team-recent-videos__button" onClick={handleLoadMore}>
        <span>{toTitleCase(I18N.t("LOAD_MORE"))}</span>
      </button>
      <VideoPreviewActions
        displayedModal={displayedModal}
        closeModal={closeModal}
        selectedVideoContainer={selectedVideoContainer}
        currentTeamMembers={members}
      />
    </div>
  )
};

export default inject("TeamsStore", "VideosStore")(observer(TeamRecentVideos));